var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-select",
        {
          ref: "vue_select",
          attrs: {
            label: "title",
            placeholder: "Препарат",
            filterable: false,
            options: _vm.options,
          },
          on: { input: _vm.select, search: _vm.onSearchDrug },
          nativeOn: {
            keypress: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function (option) {
                return [
                  _c(
                    "div",
                    { staticClass: "d-center" },
                    [
                      option.company_id
                        ? _c("span", { staticClass: "badge badge-warning" }, [
                            _vm._v("АнУ"),
                          ])
                        : _vm._e(),
                      _vm._v(
                        " \n        " + _vm._s(option.title) + "\n        "
                      ),
                      option.substance
                        ? [_vm._v(":: " + _vm._s(option.substance))]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              },
            },
            {
              key: "selected-option",
              fn: function (option) {
                return [
                  option.company_id
                    ? _c("span", { staticClass: "badge badge-warning" }, [
                        _vm._v("АнУ"),
                      ])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(option.title) + "\n      "),
                  option.substance
                    ? [_vm._v(":: " + _vm._s(option.substance))]
                    : _vm._e(),
                ]
              },
            },
          ]),
          model: {
            value: _vm.drug,
            callback: function ($$v) {
              _vm.drug = $$v
            },
            expression: "drug",
          },
        },
        [
          _c("template", { slot: "no-options" }, [
            _vm._v("\n      введите название препарата..\n    "),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }